"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ModuleListTypes_1 = require("components/moduleList/ModuleListTypes");
const pageRibbonColor_module_scss_1 = __importDefault(require("./pageRibbonColor.module.scss"));
const PAGE_TYPE_COLOR = {
    [ModuleListTypes_1.PageType.Advertisement]: 'cyan',
    [ModuleListTypes_1.PageType.Content]: '0',
    [ModuleListTypes_1.PageType.Quiz]: 'purple-light',
    [ModuleListTypes_1.PageType.Webinar]: 'brand-primary-lighter'
};
const PageRibbonColor = ({ pageType }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(pageRibbonColor_module_scss_1.default.ribbon, `_border-${PAGE_TYPE_COLOR[pageType]}`) }));
};
exports.default = PageRibbonColor;
